import i18_actionCenter from "../../resources/newui/uk-UA/i18_actionCenter.json" 
import i18_checklist from "../../resources/newui/uk-UA/i18_checklist.json" 
import i18_feedPreviewItems from "../../resources/newui/uk-UA/i18_feedPreviewItems.json" 
import i18_fullview from "../../resources/newui/uk-UA/i18_fullview.json" 
import i18_fullviewSideMenu from "../../resources/newui/uk-UA/i18_fullviewSideMenu.json" 
import i18_groupSettings from "../../resources/newui/uk-UA/i18_groupSettings.json" 
import i18_item from "../../resources/newui/uk-UA/i18_item.json" 
import i18_manageMembers from "../../resources/newui/uk-UA/i18_manageMembers.json" 
import i18_moveGroup from "../../resources/newui/uk-UA/i18_moveGroup.json" 
import i18_newKanban from "../../resources/newui/uk-UA/i18_newKanban.json" 
import i18_snackbar from "../../resources/newui/uk-UA/i18_snackbar.json" 
import i18_userWidget from "../../resources/newui/uk-UA/i18_userWidget.json" 
import i18_library from "../../resources/newui/uk-UA/i18_library.json" 
import i18_admin from "../../resources/newui/uk-UA/i18_admin.json" 
import inputTypes from "../../resources/newui/uk-UA/inputTypes.json" 
import i18_editProfile from "../../resources/newui/uk-UA/i18_editProfile.json" 

export const ukua = {
	i18_admin,
	i18_library,
	i18_actionCenter, 
	i18_checklist, 
	i18_feedPreviewItems, 
	i18_fullview, 
	i18_fullviewSideMenu, 
	i18_groupSettings, 
	i18_item, 
	i18_manageMembers, 
	i18_moveGroup, 
	i18_newKanban, 
	i18_snackbar, 
	i18_userWidget, 
	i18_editProfile, 
	inputTypes, 
}